import ImageUploader from 'react-images-upload';

const ImageSelector = ({ visible, onImageSelected }) => {
  if (!visible) {
    return null;
  }

  const onDrop = (files) => {
    const fr = new FileReader();
    fr.onload = () => {
      const image = new Image();
      image.crossOrigin = 'Anonymous';
      image.src = fr.result;
      image.onload = () => onImageSelected(image);
    };
    fr.readAsDataURL(files[0]);
  };

  return (
    <ImageUploader
      withIcon={false}
      withLabel={false}
      buttonText="Choose Image"
      onChange={onDrop}
      imgExtension={['.jpg', '.png', '.jpeg']}
      maxFileSize={5242880}
      singleImage={true}
    />
  );
};

export default ImageSelector;
